import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useDispatch } from 'react-redux';
import { fetchO365Licenses, fetchO365Users } from '../features/o365/O365Slice';
import { fetchHistory } from '../features/History/HistorySlice';
import { fetchOrganizations } from '../features/Organization/OrganizationSlice';
import { fetchEsetDevices, fetchEsetLicenses } from '../features/Eset/EsetSlice';
import { fetchUsers } from '../features/User/UserSlice';

const useAuthenticatedBootstrap = () => {
  const { user, loading } = useAuth();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!loading && user) {
        console.log("USER")
      // L'utilisateur est prêt, on peut précharger les données liées à son organisation
      dispatch(fetchO365Licenses()); // chargement initial
      dispatch(fetchO365Users()); // chargement initial
      dispatch(fetchHistory()); // chargement initial
      dispatch(fetchOrganizations()); // chargement initial
      dispatch(fetchEsetDevices()); // chargement initial
      dispatch(fetchEsetLicenses()); // chargement initial
      dispatch(fetchUsers()); // chargement initial
    }
  }, [loading, user, dispatch]);
};

export default useAuthenticatedBootstrap;
